/* global ApplePaySession */

import React, {useState,useContext,useRef,useEffect} from "react";

import { useNavigate  } from "react-router-dom";
import Lang from '../../../lang/translations';
import helpers from "../../../_helpers/helpersFunction";
import PopupGenerico from '../../../popup/popupGenerico';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {Helmet} from "react-helmet";

import Context from '../../../context/context';

const config = require("../../../_helpers/configServizi"); 


export default function Coda(props) {
        let navigate = useNavigate();
        const context = useContext(Context)
    
        const domain = window.location.hostname;
        const [spinner, setSpinner] = useState(false);

        useEffect(() => {
         
        }, []);

        function Spinner(){
        
            if(spinner){
              return (<div className="waiterAdattivo">
                  <div className="spinner-adattivo" role="status">
              <span className="sr-only"></span>
              
            </div>
            <div className="testoSpinner">
                  <Lang w={"redirigendo"} page={"pianiAbbonamento"}/>
            </div>
          
            </div>);
            }return false
          }
      

        async function creaIntentoDiPagamento() {
            setSpinner(true);
            const d = new Date();
            
            const data = {
                country : helpers.getCountry(),
                rateplan : context.rateplanScelto,
                descriptor : config.servizi[domain].descriptor,
                payment_company : config.servizi[domain].payment_company,
                city : localStorage.getItem("city"),
                clickid : localStorage.getItem("trackerId"),
                domain : window.location.hostname,
                paySource : "CREDITCARD",
                email : context.email,
                newCard : context.newCard,
                actonfile : false,
                userAgent: navigator.userAgent,
                pacchettone: context.flusso.rateplans?.pacchettone?.id
            }



            const response = await tryChargeCoda(data);
   
            
            if (response.result == "ok" && response.redirectUrl) {

              window.location.href = response.redirectUrl;
              setSpinner(false);

            } else {
                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                helpers.showPopupgenerico("blocked",context,contenuto)
            }
        }



        async function tryChargeCoda(dati){
            var token = localStorage.getItem('token');
            try{
          
              return await fetch(process.env.REACT_APP_PAY+"/orders/coda/createPayment",{ 
                method: 'post', 
                headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer '+ token
                },
                body: JSON.stringify(dati)
              })
              .then(res => res.json())
              .then(response => {
                return response
              })
              .catch((err)=>{
                 helpers.logToBackend("tryCharge 1",{clickid:dati.clickid,error:err.message})
              })
            }catch(err){
               helpers.logToBackend("tryCharge try catch",{clickid:dati.clickid,error:err.message})
            }
          }
        
     
        return (<>
            {spinner ? (<Spinner/>) : (<button style={{fontSize:"0.6em" }} className="btn btn-block choose" onClick={()=>{creaIntentoDiPagamento(); }}><div><img src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png" border="0" alt="PayPal Logo"/></div></button>)}
                    
                    
                </>)
}